import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";

import { AdminAuthService } from "@/service/api/admin-auth";
import { SendRecoverPasswordCodeDto } from "@/service/dto/admin-auth";

const useSendRecoveryCode = () => {
  return useMutation({
    mutationFn: async (data: SendRecoverPasswordCodeDto) => {
      try {
        await AdminAuthService.sendRecoveryCode(data);
      } catch (error) {
        if (error instanceof AxiosError && error.response?.status === 404) return;
        throw error;
      }
    },
    onSuccess: () => {
      toast.info("Se o e-mail informado estiver cadastrado, você receberá um novo código em instantes.", {
        toastId: "send_recovery_code",
      });
    },
    onError: () => {
      toast.error("Erro ao enviar o código de recuperação. Tente novamente mais tarde.", { toastId: "send_recovery_code_error" });
    },
  });
};

export default useSendRecoveryCode;
